<template>
    <div class="flex-column h-100">
      <div class="flex mb-10">
        <div class="title flex align-center bg-ff flex-1 h-0">
          <div class="decoration-line mr-5"></div>
          <div class="font-16-f5971d font-bold">实际用量表</div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
      <div class="flex-1 h-0 mb-10">
        <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData"></erp-table>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import Pagination from '@/components/Pagination'
export default {
  name: 'actualAmount',
  components: {ErpTable, Pagination},
  props: ['budgetGroup'],
  data () {
    return {
      loading: true,
      keywords: null,
      tableData: [],
      columnData: [{
        field: 'specialItem',
        title: '特项',
        width: '80'
      }, {
        field: 'name',
        title: '材料名称',
        width: '350'
      }, {
        field: 'businessName',
        title: '供应商',
        width: '350'
      }, {
        field: 'subitem',
        title: '价格类型',
        minWidth: '150'
      }, {
        field: 'unit',
        title: '单位',
        width: '100'
      }, {
        field: 'quantity',
        title: '数量',
        width: '120'
      }, {
        field: 'availableQuantity',
        title: '剩余可开数量',
        width: '100'
      }, {
        field: 'actualQuantity',
        title: '实际领用量',
        width: '150'
      }],
      currentMenu: null,
      page: 1,
      limit: 30,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100 // 总条数
    }
  },
  created () {
    this.getData()
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  },
  methods: {
    getData () {
      this.axios.post(`budgetContent/requirementMaterialListForPM`, {
        customerId: this.budgetGroup.customerId,
        page: this.page,
        limit: this.limit,
        keywords: this.keywords
      }).then(res => {
        if (res.data.success) {
          if (res.data.data.list.length === 0) {
            this.$alert('没有填核算量或未锁定', '提示', {
              confirmButtonText: '确定'
            })
          }
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    searchBtn () {
      this.page = 1
      this.loading = true
      this.getData()
    },
    jump (page) {
      this.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/budgetItem/actualAmount.vue